export default {"src":"/_next/static/media/contact-circular.a4418504.svg","height":138,"width":139,"blurWidth":0,"blurHeight":0};